import { AttachablePluginInterface } from "./CesiumWrapper";
import { DeferredValue, Guard } from "lib/actions/util";
import { Viewer, ImageryLayer, IonImageryProvider } from "cesium";

export default class RasterLayerPlugin implements AttachablePluginInterface {
  private readonly _viewer = new DeferredValue<Viewer>();
  private _state: { [contentUri: string]: ImageryLayer } = {};

  setViewer(viewer: Viewer): void {
    this._viewer.set(viewer);
  }

  detachViewer(): void {
    this._state = {};
    this._viewer.clear();
  }

  get(id: string) {
    Guard.require(id, "id");
    return this._state[id] ?? null;
  }

  isExisting(id: string) {
    Guard.require(id, "id");
    return !!this.get(id);
  }

  isShowing(id: string) {
    Guard.require(id, "id");
    return !!this.get(id)?.show;
  }

  async load(id: string, imageryLayer: ImageryLayer) {
    Guard.require(id, "id");
    if (this.get(id)) return;

    const viewer = await this._viewer.getValueWhenReady();
    if (!viewer) return;

    viewer.imageryLayers.add(imageryLayer);
    this._state[id] = imageryLayer;
    viewer.scene.requestRender();
  }

  show(id: string) {
    const layer = this.get(id);
    if (layer) {
      layer.show = true;
      this._viewer.current?.scene.requestRender();
    }
  }

  hide(id: string) {
    const layer = this.get(id);
    if (layer) {
      layer.show = false;
      this._viewer.current?.scene.requestRender();
    }
  }
}
